import styled from 'styled-components';

export const InfoContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  align-items: center;
  color: ${({ theme }) => theme.colors.footer_headings};
  font-size: ${({ theme }) => theme.fontSize.sm};
  margin-left: 32px;
  padding-bottom: 5px;

  @media (max-width: 1024px) {
    margin-left: 0px;
    margin-bottom: 10px;
    padding-bottom: 0;
    justify-content: flex-start;
  }

  @media (max-width: 512px) {
    justify-content: space-between;
  }
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  flex: 1;
  margin-top: 17px;
  margin-left: 32px;
  padding-bottom: 10px;

  @media (max-width: 1024px) {
    margin-left: 0;
    margin-top: 0;
  }

  @media (max-width: 512px) {
    margin-top: 0;
    padding: 15px 10px;
    margin: 0 -10px;
    background-color: ${({ theme }) => theme.colors.color_bg};
    border-top: 1px solid rgba(89, 110, 129, 0.2);
    border-bottom: 1px solid rgba(89, 110, 129, 0.2);
  }
`;

export const Complaint = styled.div`
  margin-right: 8px;
  margin-left: auto;
`;
